import useSWR from 'swr';

import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { Operatory } from 'interfaces/operatory';
import ServiceScheduleException from 'interfaces/serviceScheduleException';

interface IUseServiceCustomDaysParams {
  startDate: string;
  endDate: string;
  serviceId: string;
}

export interface ServiceCustomDay {
  clinicId: string;
  date: string;
  endTime: string;
  id: string;
  isAvailable: boolean;
  operatories: Operatory[];
  serviceId: string;
  startTime: string;
}

const useServiceCustomDays = ({
  startDate,
  endDate,
  serviceId,
}: IUseServiceCustomDaysParams) => {
  const query = new URLSearchParams({
    startDate,
    endDate,
  }).toString();

  const clinicId = loadSelectedClinicId();
  const url = `/services/${serviceId}/custom-days?${query}`;

  const { data, error, mutate } = useSWR<ServiceScheduleException[]>(
    [url, clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useServiceCustomDays;
